import FORBES_BANNER from '../assets/news-banner/Image 7-1.png';
import ZENDESK_BANNER from '../assets/news-banner/18-km-benefits-1.png';
import BBC_BANNER from '../assets/news-banner/photo-1551288049-bebda4e38f71-1.png';

import FORBES_ICON from '../assets/source/Image 16-1@2x.png';
import BBC_ICON from '../assets/source/download-1@2x copy.png';
import ZENDESK_ICON from '../assets/source/WLwRt2Wv_400x400-1@2x.png';

export const DATA = [{
  url: '',
  title: '6 ways to achieve ‘wow’ customer service and create lifelong customers',
  description: '7h ago · All humans, including the humans we call "customers," tend to remember what happens',
  sourceTitle: 'Forbes',
  domain: 'https://www.forbes.com/',
  favicon: FORBES_ICON,
  image: FORBES_BANNER,
}, {
  url: '',
  title: 'How do organizations spread and use analytic knowledge?',
  description: '7h ago · There are many ways to achieve great analytic cultures, but all great analytic cultures share some common elements. The best',
  sourceTitle: 'BBC Future',
  domain: 'https://www.bbc.com/future/',
  favicon: BBC_ICON,
  image: BBC_BANNER,
}, {
  url: '',
  title: 'The benefits of knowledge management for your service desk',
  description: '7h ago · Getting knowledge management right has never been easy. You know that in the long run, recording the knowledge of your service desk',
  sourceTitle: 'Zendesk',
  domain: 'https://www.zendesk.com/',
  favicon: ZENDESK_ICON,
  image: ZENDESK_BANNER,
  },
]